import { resetReducerKeys } from '../../constants/app-constants';
import { UserProfileMeService } from '../../services';
import types from './types';

const setUser = (data) => (
    {
        type: types.SET_USER,
        data
    }
);

const resetUser = () => ({
    type: resetReducerKeys.RESET_USER
});

const getUserConsent = (params, country = 'AE') => dispatch => {
    return new Promise((resolve, reject) => {
        UserProfileMeService.getUserConsent(params, country)
            .then(response => {
                resolve(response.data);
                dispatch(setUser(response?.data));
            }).catch(error => reject(error));
    });
};
const userDeactivation = (payload) => () => {
    return new Promise((resolve, reject) => {
        UserProfileMeService.userDeactivation(payload)
            .then(response => resolve(response))
            .catch(error => reject(error));
    });
};

export {
    setUser,
    resetUser,
    getUserConsent,
    userDeactivation
};
